export const DEFAULT_THEME_ID = "eudemonie-naturelle";
export const THEME_EVENT = "eudemonie:theme-change";

export const THEMES = [
  {
    id: DEFAULT_THEME_ID,
    version: 1,
    name: "Eudémonie naturelle",
    description: "La charte de référence, douce, organique et thérapeutique.",
    badges: ["Clair", "Doux", "Référence"],
    heading: '"Playfair Display", serif',
    body: '"Manrope", sans-serif',
    colors: ["#FAF9F6", "#7C9082", "#2A332C", "#D4A373", "#E5E0D5"],
  },
  {
    id: "zen",
    version: 1,
    name: "ZEN",
    description: "Papier washi, thé matcha et encre végétale pour une interface silencieuse et essentielle.",
    badges: ["Épuré", "Japonisant", "Apaisant"],
    heading: '"Zen Old Mincho", serif',
    body: '"Zen Kaku Gothic New", sans-serif',
    colors: ["#F7F4EC", "#5F735F", "#27332D", "#B56F52", "#D9DED3"],
  },
  {
    id: "empreintezen",
    version: 1,
    name: "EmpreinteZen",
    description: "Bleu canard immersif, ivoire et accent corail pour une vitrine de massothérapie très photographique.",
    badges: ["Immersif", "Photographique", "Massage"],
    heading: '"Space Mono", monospace',
    body: '"DM Sans", sans-serif',
    colors: ["#F8F5F0", "#0A8793", "#18383C", "#F18755", "#DCEBEC"],
  },
  {
    id: "prepm-b4",
    version: 1,
    name: "Prep'M B.4",
    description: "Bleu nuit, papier ivoire et doré pour une identité institutionnelle nette et énergique.",
    badges: ["Bleu nuit", "Doré", "Institutionnel"],
    heading: '"Barlow Condensed", sans-serif',
    body: '"Inter", sans-serif',
    colors: ["#F7F4EF", "#001A33", "#071B33", "#D99535", "#EEE9E1"],
  },
  {
    id: "prepm",
    version: 1,
    name: "Prep'M",
    description: "Bleu nuit profond, blanc cassé et or franc, avec une typographie condensée orientée performance.",
    badges: ["Performance", "B2B", "Éditorial"],
    heading: '"Barlow Condensed", sans-serif',
    body: '"Inter", sans-serif',
    colors: ["#F7F4EF", "#06182D", "#071B33", "#E5A13A", "#E9E4DC"],
  },
  {
    id: "serein-mineral",
    version: 1,
    name: "Serein minéral",
    description: "Pierre claire, bleu ardoise et structure professionnelle.",
    badges: ["Clair", "Structuré", "Cabinet"],
    heading: '"Fraunces", serif',
    body: '"DM Sans", sans-serif',
    colors: ["#F7F9F8", "#5B7E84", "#1E2D35", "#B09264", "#DDE5E4"],
  },
  {
    id: "harmonie-tactile",
    version: 1,
    name: "Harmonie tactile",
    description: "Cacao, argile, sable et eucalyptus pour une expérience sensorielle chaleureuse.",
    badges: ["Massage", "Sensoriel", "Chaleureux"],
    heading: '"Fraunces", serif',
    body: '"DM Sans", sans-serif',
    colors: ["#F7F0E5", "#667C6A", "#272321", "#B87352", "#E8D7BE"],
  },
  {
    id: "souffles",
    version: 1,
    name: "Équilibre des Souffles",
    description: "Encre, jade, terre cuite et papier de riz pour une approche précise et contemporaine.",
    badges: ["Énergétique", "Éditorial", "Calme"],
    heading: '"Libre Baskerville", serif',
    body: '"Manrope", sans-serif',
    colors: ["#F5F0E7", "#526E5A", "#18332F", "#B56F4B", "#E5ECE6"],
  },
  {
    id: "lumiere-botanique",
    version: 1,
    name: "Lumière botanique",
    description: "Crème solaire, olive et terracotta pour une vitrine lumineuse.",
    badges: ["Lumineux", "Organique", "Éditorial"],
    heading: '"Lora", serif',
    body: '"Nunito Sans", sans-serif',
    colors: ["#FDFAF2", "#77844C", "#2F3A27", "#C67C52", "#EFE3C8"],
  },
  {
    id: "cabinet-editorial",
    version: 1,
    name: "Cabinet éditorial",
    description: "Papier chaud, encre et bordeaux, comme un carnet de praticienne.",
    badges: ["Éditorial", "Affirmé", "Chaleureux"],
    heading: '"Libre Baskerville", serif',
    body: '"Source Sans 3", sans-serif',
    colors: ["#FAF7F1", "#71353D", "#1B2836", "#B78630", "#E7DCC9"],
  },
  {
    id: "clarte-renforcee",
    version: 1,
    name: "Clarté renforcée",
    description: "Contrastes élevés, contours visibles et lecture prioritaire.",
    badges: ["Contraste AA", "Accessible", "Net"],
    heading: '"Source Serif 4", serif',
    body: '"Atkinson Hyperlegible", sans-serif',
    colors: ["#FFFFFF", "#005E7A", "#0F1C28", "#B74B00", "#D6E2EA"],
  },
];

export function themeById(id) {
  return THEMES.find(theme => theme.id === id) || THEMES[0];
}

export function applyTheme(id) {
  const theme = themeById(id);
  document.documentElement.dataset.theme = theme.id;
  return theme;
}

export function announceTheme(id) {
  const theme = applyTheme(id);
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: theme.id }));
  return theme;
}
